import React from "react";
import { useTranslation } from "react-i18next";
import useApi from "@/res/hooks/SynegaApi";
import { useServiceContext } from "@/res/context/ServiceContext";
import useStringInput from "@/res/hooks/Form/useStringInput";
import usePhoneInput from "@/res/hooks/Form/usePhoneInput";
import useEmailInput from "@/res/hooks/Form/useEmailInput";

const InDevelopment = (props) => {
    const [t] = useTranslation();
    const api = useApi(2);
    const serviceContext = useServiceContext();

    const [uploading, setUploading] = props.uploadingState;

    const nameInput = useStringInput({
        key: "client.contact_person.name", context: serviceContext, class: "small",
        label: t("_shared.form.name-label"), placeholder: t("_shared.form.name-placeholder"),
    });
    const phoneInput = usePhoneInput({
        key: "client.contact_person.phone_number", context: serviceContext, class: "small",
        label: t("_shared.form.phone-label"),
    });
    const emailInput = useEmailInput({
        key: "client.contact_person.email", context: serviceContext, class: "small",
        label: t("_shared.form.email-label"), placeholder: t("_shared.form.email-placeholder"),
    });

    const enquiry = (e) => {
        e.preventDefault();

        setUploading(true);
        api.post("/leads", {
            data: {
                type: "waitlist",
                app: serviceContext?.state?.shared?.service_code,
                client: {
                    name: nameInput.value,
                    email: emailInput.value,
                    phone: phoneInput.value,
                },
                notes: "The client would like to be contacted when the service is available.",
            },
        });
    };

    return (
        <form className="card-container enable-pointer-events" onSubmit={enquiry}>
            { uploading &&
                <h5 className="center">
                    {t("pages.start.in-development.form-completion")}
                </h5>
            }

            { !uploading &&
                <>
                    <h5 className="center">
                        { t("pages.start.in-development.form-header") }
                    </h5>

                    { nameInput.render() }
                    <div className="input-group">
                        { emailInput.render() }
                        { phoneInput.render() }
                    </div>

                    <div style={{ margin: "1.4rem 0" }}/>
                    {/* TODO */ }
                    <div className="button-group">
                        <button className="btn">
                            { t("pages.start.in-development.form-button") }
                        </button>
                    </div>
                </>
            }
        </form>
    );
};

export default InDevelopment;
